export const MIN_PASSWORD_LENGTH = 16;
// No business maximum: this ceiling only keeps an enormous input from
// stalling the server while hashing it.
export const MAX_PASSWORD_LENGTH = 1_024;

export enum PasswordRuleViolation {
  Missing = 'Missing',
  TooShort = 'TooShort',
  TooLong = 'TooLong',
}

// Counted in Unicode code points: an accented letter or an emoji is one
// character, as the user sees it.
export const countPasswordCharacters = (password: string): number =>
  Array.from(password).length;

// Any character is allowed (spaces, accents...): no complexity rule, only the
// length counts.
export const findPasswordRuleViolation = (
  password: string | null | undefined,
): PasswordRuleViolation | null => {
  if (!password) {
    return PasswordRuleViolation.Missing;
  }

  const length = countPasswordCharacters(password);

  if (length < MIN_PASSWORD_LENGTH) {
    return PasswordRuleViolation.TooShort;
  }

  return length > MAX_PASSWORD_LENGTH ? PasswordRuleViolation.TooLong : null;
};
